import { FaSolidArrowRotateLeft, FaSolidMinus, FaSolidPlus } from 'solid-icons/fa'
import { parse } from 'valibot'
import Button from '../../lib/jsx/Button'
import { PERSPECTIVE_CAMERA_FAR_DEFAULT, PERSPECTIVE_CAMERA_FAR_MAX, PERSPECTIVE_CAMERA_FAR_MIN, PERSPECTIVE_CAMERA_FAR_STEP } from '../../rx/shared/device/userPreference/CameraFar'
import { PERSPECTIVE_CAMERA_FOV_DEFAULT, PERSPECTIVE_CAMERA_FOV_MAX, PERSPECTIVE_CAMERA_FOV_MIN, PERSPECTIVE_CAMERA_FOV_STEP } from '../../rx/shared/device/userPreference/CameraFov'
import { getDeviceUserPreference, setDeviceUserPreference } from '../../rx/shared/device/userPreference/deviceUserPreferencesSignal'
import { PIXELATION_SHADER_INTENSITY_VALUE_DEFAULT, PIXELATION_SHADER_INTENSITY_VALUE_MAX, PIXELATION_SHADER_INTENSITY_VALUE_MIN, PIXELATION_SHADER_INTENSITY_VALUE_STEP } from '../../rx/shared/device/userPreference/PixelationShaderIntensityValue'
import { PowerPreferenceSchema } from '../../rx/shared/device/userPreference/PowerPreference'
import { updateCameraFar } from '../../rx/shared/device/userPreference/updateCameraFar'
import { updateCameraFov } from '../../rx/shared/device/userPreference/updateCameraFov'
import { updatePixelationShaderIntensityValue } from '../../rx/shared/device/userPreference/updatePixelationShaderIntensityValue'
import type { MainMenuObj } from './MainMenuObj.type'
import ModalMenuMain from './ModalMenuMain'

const ModalMenuDeviceSettings: MainMenuObj = {
  dname: 'Device Settings',
  parents: () => [ModalMenuMain],
  fn() {

    const pref = getDeviceUserPreference

    return (
      <table class="table table-striped table-hover">
        <tbody>
          <tr>
            <th>Power Preference</th>
            <td>
              <select class="form-select" value={pref().powerPreference}
                onInput={(event: InputEvent) => {
                  console.log('event', event)
                  const powerPreference = parse(PowerPreferenceSchema, (event.target as HTMLSelectElement)?.value)
                  console.log('powerPreference', powerPreference)
                  setDeviceUserPreference({
                    ...pref(),
                    powerPreference,
                  })
                }}
              >
                <option value="high-performance">High Performance</option>
                <option value="default">Auto</option>
                <option value="low-power">Low Power</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>Anti-Aliasing</th>
            <td>
              {pref().antialias}
              <Button classList={{
                'btn': true,
                'btn-success': pref().antialias,
                'btn-danger': !pref().antialias,
              }} onClick={() => {
                setDeviceUserPreference({
                  ...pref(),
                  antialias: !pref().antialias,
                })
              }}>{pref().antialias ? 'On' : 'Off'}</Button>
            </td>
          </tr>
          <tr>
            <th>HiDPI</th>
            <td>
              {pref().HiDPI}
              <Button classList={{
                'btn': true,
                'btn-success': pref().HiDPI,
                'btn-danger': !pref().HiDPI,
              }} onClick={() => {
                setDeviceUserPreference({
                  ...pref(),
                  HiDPI: !pref().HiDPI,
                })
              }}>{pref().HiDPI ? 'On' : 'Off'}</Button>
            </td>
          </tr>
          <tr>
            <th>Pixelation Shader</th>
            <td class="d-flex align-items-center">
              <Button class="btn btn-danger"
                disabled={pref().psiv === PIXELATION_SHADER_INTENSITY_VALUE_DEFAULT}
                onClick={() => {
                  updatePixelationShaderIntensityValue(PIXELATION_SHADER_INTENSITY_VALUE_DEFAULT)
                }}><FaSolidArrowRotateLeft /></Button>
              <div class="btn btn-group btn-group flex-grow-1">
                <Button class="btn btn-primary"
                  disabled={pref().psiv <= PIXELATION_SHADER_INTENSITY_VALUE_MIN}
                  onClick={() => {
                    updatePixelationShaderIntensityValue(pref().psiv - PIXELATION_SHADER_INTENSITY_VALUE_STEP)
                  }}><FaSolidMinus /></Button>
                <div class="btn btn-secondary w-100">{pref().psiv}</div>
                <Button class="btn btn-primary"
                  disabled={pref().psiv >= PIXELATION_SHADER_INTENSITY_VALUE_MAX}
                  onClick={() => {
                    updatePixelationShaderIntensityValue(pref().psiv + PIXELATION_SHADER_INTENSITY_VALUE_STEP)
                  }}><FaSolidPlus /></Button>
              </div>
            </td>
          </tr>
          <tr>
            <th>Camera FOV</th>
            <td class="d-flex align-items-center">
              <Button class="btn btn-danger"
                disabled={pref().camera_fov === PERSPECTIVE_CAMERA_FOV_DEFAULT}
                onClick={() => {
                  updateCameraFov(PERSPECTIVE_CAMERA_FOV_DEFAULT)
                }}><FaSolidArrowRotateLeft /></Button>
              <div class="btn btn-group btn-group flex-grow-1">
                <Button class="btn btn-primary"
                  disabled={pref().camera_fov <= PERSPECTIVE_CAMERA_FOV_MIN}
                  onClick={() => {
                    updateCameraFov(pref().camera_fov - PERSPECTIVE_CAMERA_FOV_STEP)
                  }}><FaSolidMinus /></Button>
                <div class="btn btn-secondary w-100">{pref().camera_fov}</div>
                <Button class="btn btn-primary"
                  disabled={pref().camera_fov >= PERSPECTIVE_CAMERA_FOV_MAX}
                  onClick={() => {
                    updateCameraFov(pref().camera_fov + PERSPECTIVE_CAMERA_FOV_STEP)
                  }}><FaSolidPlus /></Button>
              </div>
            </td>
          </tr>
          <tr>
            <th>Camera Far</th>
            <td class="d-flex align-items-center">
              <Button class="btn btn-danger"
                disabled={pref().camera_far === PERSPECTIVE_CAMERA_FAR_DEFAULT}
                onClick={() => {
                  updateCameraFar(PERSPECTIVE_CAMERA_FAR_DEFAULT)
                }}><FaSolidArrowRotateLeft /></Button>
              <div class="btn btn-group flex-grow-1">
                <Button class="btn btn-primary"
                  disabled={pref().camera_far <= PERSPECTIVE_CAMERA_FAR_MIN}
                  onClick={() => {
                    updateCameraFar(pref().camera_far - PERSPECTIVE_CAMERA_FAR_STEP)
                  }}><FaSolidMinus /></Button>
                <div class="btn btn-secondary w-100">{pref().camera_far}</div>
                <Button class="btn btn-primary"
                  disabled={pref().camera_far >= PERSPECTIVE_CAMERA_FAR_MAX}
                  onClick={() => {
                    updateCameraFar(pref().camera_far + PERSPECTIVE_CAMERA_FAR_STEP)
                  }}><FaSolidPlus /></Button>
              </div>
            </td>
          </tr>
        </tbody>
      </table >
    )
  }
}

export default ModalMenuDeviceSettings
